import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;
export interface IListingToUpdate {
	NewSection: string;
	NewRow: string;
	ListingIds: Array<number>;
	SectionLocked?: boolean;
	RowLocked?: boolean;
	SeatLocked?: boolean;
}
export const { thunk: updateListingPosition, slice: updateListingPositionSlice } = getThunkAndSlice<
	IListingToUpdate,
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/UpdateListingPosition",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const listingIds = new Set<number>(params.ListingIds);

		const newData = rootState.pricing.eventInventoryAll.data.map((event) => {
			return listingIds.has(event.Listing_ID)
				? {
						...event,
						Section: params.NewSection,
						Row: params.NewRow,
						Section_Locked: !!params.SectionLocked,
						Row_Locked: !!params.RowLocked,
						Seat_Locked: !!params.SeatLocked,
					}
				: event;
		});

		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId: getInventoryCacheEventId(rootState) }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((item) => {
				return listingIds.has(item.Listing_ID)
					? {
							...item,
							Section: params.NewSection,
							Row: params.NewRow,
							Section_Locked: !!params.SectionLocked,
							Row_Locked: !!params.RowLocked,
							Seat_Locked: !!params.SeatLocked,
						}
					: item;
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
